import React, { Component } from 'react'
import classes from './MobileMenu.scss'
import classNames from 'classnames'
import { Link } from 'react-router'
import sLay from 'styles/modules/layout.scss'
import Button from 'components/Button'
import sMarg from 'styles/modules/margins.scss'
import IconPhoneHandset from 'components/Icons/PhoneHandset'

export default class MobileMenu extends Component {
  render() {
    const { items, isOpen, ...otherProps } = this.props

    return (
      <div
        className={classNames(classes.mobileLinks, sLay['hide-gt-md'], sLay['layout-column'], {
          [classes.show]: isOpen,
        })}
      >
        <div className={sMarg.mt30} />
        {items.map(item => (
          <Link
            key={item.name}
            activeClassName="active"
            className={classNames(
              classes.mobileLink,
              sLay['layout-row'],
              sLay['layout-align-center-center']
            )}
            to={item.to}
            {...otherProps}
          >
            {item.name}
          </Link>
        ))}
        <div className={classNames(sLay['layout-column'], sLay['layout-align-center-center'])}>
          <Button color="tertiary" className={sMarg.mv30} to="/join">
            Sign up
          </Button>
          <Button color="tertiary" ghost to="/login">
            Sign in
          </Button>
        </div>
        <div className={sLay.flex} />
        <div className={classNames(sLay['layout-column'], sLay['layout-align-end-center'])}>
          <div className={classNames(classes.info, sMarg.mb15)}>Just want to talk to a person?</div>
          <div
            className={classNames(
              sLay['layout-row'],
              sLay['layout-align-start-center'],
              classes.info,
              sMarg.mb30
            )}
          >
            <IconPhoneHandset size={20} style={{ marginRight: '10px' }} />
            1300 688 588
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/MobileMenu/MobileMenu.jsx